import { FACILITIES } from "../data/content";
import { SectionHeader } from "./SectionHeader";
import { Reveal } from "./Reveal";

const CARD_VARIANTS = [
    {
        card: "bg-bh-deep",
        chip: "bg-white/10",
        icon: "text-bh-softgold",
        num: "text-bh-gold",
        title: "text-white",
        desc: "text-white/75",
    },
    {
        card: "bg-bh-softgold",
        chip: "bg-white/70",
        icon: "text-bh-dark",
        num: "text-bh-deep/70",
        title: "text-bh-ink",
        desc: "text-bh-ink/75",
    },
    {
        card: "bg-bh-light",
        chip: "bg-white",
        icon: "text-bh-green",
        num: "text-bh-green/60",
        title: "text-bh-deep",
        desc: "text-bh-ink/70",
    },
    {
        card: "bg-white border border-bh-green/12",
        chip: "bg-bh-light",
        icon: "text-bh-green",
        num: "text-bh-green/60",
        title: "text-bh-deep",
        desc: "text-bh-gray",
    },
];

export const Facilities = () => (
    <section
        id="fasilitas"
        data-testid="fasilitas-section"
        aria-labelledby="fasilitas-title"
        className="bg-white py-24 sm:py-32 scroll-mt-20"
    >
        <div className="max-w-[1565px] mx-auto">
            <SectionHeader
                eyebrow={FACILITIES.eyebrow}
                title={FACILITIES.title}
                sub={FACILITIES.sub}
                testid="fasilitas-title"
            />
            <div className="px-6 sm:px-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {FACILITIES.items.map((item, i) => {
                    const variant = CARD_VARIANTS[i % CARD_VARIANTS.length];
                    return (
                        <Reveal key={item.title} delay={(i % 4) * 0.08}>
                            <article
                                data-testid={`fasilitas-item-${i + 1}`}
                                className={`h-full rounded-2xl p-7 transition-transform duration-300 hover:-translate-y-1 ${variant.card}`}
                            >
                                <div className="flex items-start justify-between mb-7">
                                    <span
                                        className={`flex items-center justify-center w-12 h-12 rounded-full ${variant.chip}`}
                                    >
                                        <item.icon
                                            className={`w-5 h-5 ${variant.icon}`}
                                            aria-hidden="true"
                                        />
                                    </span>
                                    <span
                                        aria-hidden="true"
                                        className={`font-serif font-bold text-4xl leading-none ${variant.num}`}
                                    >
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                </div>
                                <h3 className={`text-base font-bold mb-2 ${variant.title}`}>
                                    {item.title}
                                </h3>
                                <p className={`text-sm leading-relaxed ${variant.desc}`}>
                                    {item.description}
                                </p>
                            </article>
                        </Reveal>
                    );
                })}
            </div>
        </div>
    </section>
);
